import { useSnackbar } from 'notistack';
import { type useNotificationActions } from './interfaces';

export const useNotification = () => {
  const { enqueueSnackbar } = useSnackbar();
  const actions = {
    toast: ({ content, title, type, ...props }) =>
      enqueueSnackbar(content, {
        title,
        type,
        variant: 'toast',
        TransitionProps: {
          direction: 'down',
        },
        ...props,
      }),
  } as useNotificationActions;

  return { ...actions };
};
